<template>
  <div class="exit-login-confirm">
    <ElDialog
        v-model="isShow"
        title="温馨提示"
        :width="412"
        destroy-on-close
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleCancel"
    >
      <div class="exit-login-confirm__body">
        <img src="../img/warning.png" alt="warning" class="warning-icon">
        <p class="confirm-text">是否确定要退出登录该账号?</p>
      </div>

      <template #footer>
        <div class="exit-login-confirm__footer">
          <ElButton class="btn-cancel" size="small" @click="handleCancel">
            取消
          </ElButton>
          <ElButton
              class="btn-confirm"
              type="primary"
              size="small"
              @click="handleConfirm"
          >
            确定
          </ElButton>
        </div>
      </template>
    </ElDialog>
  </div>
</template>

<script>
import {WarningFilled} from "@element-plus/icons-vue";

export default {
  name: "ExitLoginConfirm",
  components: {WarningFilled},
  emits: ["confirm"],
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    open() {
      this.isShow = true;
    },
    handleCancel() {
      this.isShow = false;
    },
    handleConfirm() {
      this.$emit("confirm");
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.exit-login-confirm {
  display: inline-block;
}

.exit-login-confirm__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0 8px;

  .warning-icon {
    color: #f5222d;
    margin-bottom: 16px;
    width: 60px;
    height: 60px;
  }

  .confirm-text {
    margin: 0;
    font-size: 14px;
    color: #333;
    text-align: center;
  }
}

.exit-login-confirm__footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 4px;

  .btn-cancel {
    min-width: 65px;
  }

  .btn-confirm {
    min-width: 65px;
    background: #1890ff !important;
  }
}
</style>
